import { gql } from "@apollo/client"

export const CHECK_FILE_NAME = gql`
    query checkFileName($checkFileNameInput: CheckFileNameInput!) {
        checkFileName(checkFileNameInput: $checkFileNameInput) {
            fileName
        }
    }
`
